import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import Loading from '../Loading';
import ChatListItem from '../Chat/ChatListItem';
import ChatGroupCreator from './ChatGroupCreator';
import stateLinker from "../../utils/stateLinker";
import qs from 'qs'
import ChatMessagesSearch from "./ChatMessagesSearch";
import Heighter from '../Helpers/Layout/Heighter';
import { inject, observer } from 'mobx-react'
import { toJS, makeObservable, observable, reaction } from 'mobx'
import {input} from "../../utils/linker";

class ChatContacts extends Component {
  contacts={ items:[], inited:false, fetching:false, };
  show_closed=false;
  create_chat=false;
  search_query='';

  constructor(props) {
    super(props);
    makeObservable(this,{
      contacts: observable,
      show_closed: observable,
      create_chat: observable,
      search_query: observable,
    });

    this.state={
      contacts:{
        items:[],
        inited:false,
        fetching:false,
      },
      show_closed:false,
      create_chat:false,
      search_query:''
    }
    this.reactions=[];
    this.reactions.push(reaction(()=>{
      return this.props.chatStore.float_window;
    },(win)=>{
      if(win === 'contacts_list') {
        this.loadContacts();
      }
    }));
    this.reactions.push(reaction(()=>{
      return this.show_closed;
    },(win)=>{
      this.loadContacts();
    }));
  }
  componentWillUnmount() {
    this.reactions.map((item)=>{ item(); });
  }

  /*
  componentDidUpdate(prevProps, prevState)
  {
    if(
      (this.props.chat_state.win==='contacts_list' && prevProps.chat_state.win !== this.props.chat_state.win  && this.props.popupMode)
      ||
      this.state.show_closed !== prevState.show_closed
    ) {
      this.loadContacts();
    }
  }
  */
  renderContacts() {
    if(!this.contacts.inited) {
      return (
        <div className="hpadd10">
          <Loading />
        </div>
      )
    } else {
      if(this.contacts.items) {
        const list = this.contacts.items.map((item) => {
          return <ChatListItem standalone={this.props.standalone} key={item.id} {...item} closeChat={(id) => {
            this.closeChat(id);
          }} openChat={(id) => {
            this.openChat(id);
          }}/>
        });
        return (
          <div>
            {list}
          </div>
        )
      } else {
        return null;
      }
    }
  }
  openChat(id) {
    axios.post(`/api/privatechat/${id}/open`).then((data)=>{
      this.loadContacts();
    });
  }
  closeChat(id) {
    axios.post(`/api/privatechat/${id}/close`).then((data)=>{
      this.loadContacts();
    });
  }
  loadContacts() {
    this.contacts.fetching=true;
    let flt='';
    if(this.show_closed) {
      flt=qs.stringify({ filter:{ '!=chat_user_opened':'1' } });
    }
    axios.get(`/api/privatechat/my?${flt}`).then((data)=>{
      this.contacts.items=data.data.answer.items;
      this.contacts.fetching=false;
      this.contacts.inited=true;
    });
  }
  componentDidMount() {
    if(this.props.standalone) {
      this.loadContacts();
    }
  }

  searchKeyDown(e) {
    if(this._searchRef && typeof this._searchRef !== 'undefined') {
      this._searchRef.keyDown(e)
    }
  }
  render() {
    if (!this.props.meStore.me.data) {
      return null;
    }
    if (this.props.chatStore.float_window === 'contacts_list' && this.props.popupMode || this.props.standalone) {
      return (

        <div className={`${this.props.standalone?'':'pf bg-w1 boxShadow chatContactsWidth'}`} style={this.props.standalone?{}:{top: 55, right: 0, zIndex: 100}}>
          <Heighter height={300} enable={this.props.standalone}>
            <div className="up12-v s-v-nowrap splice h100">
              <div className="v-cell s-v-shrink">
                <div className="up12 splice vpadd10 solid1-bottom bo-w2">
                  <div className="cell s-auto s-middle noBorder">
                    {this.create_chat?(
                      <div className="pleft5">{this.props.translateStore.t.evaPrivateChat.v2_chat_create}</div>
                      ):(
                      <input type="text" className=" w100" placeholder={this.props.translateStore.t.titles.SEARCH} {...input(this,'search_query')} onKeyDown={(e)=>{ this.searchKeyDown(e); }}  />
                    )}
                  </div>
                  {!this.create_chat && !this.search_query?(
                    <div className="cell s-shrink s-middle">
                      <i className={`mdi mdi-eye fs20 hpadd10 pointer  db ${this.show_closed?'pc1':'w4'}`} onClick={()=>{ this.show_closed=!this.show_closed; }}></i>
                    </div>
                  ):null}
                  <div className="cell s-shrink ofh s-middle">
                    <i className="mdi mdi-plus fs20 hpadd10 pointer w4 db" style={{transform:this.create_chat || this.search_query?'rotate(45deg)':null}} onClick={()=>{ if(this.search_query) { this.search_query=''; } else { this.create_chat=!this.create_chat; this.search_query=''; } }}></i>
                  </div>
                </div>
              </div>
              <div className="v-cell ofh s-v-auto">
                {this.create_chat?(
                    <ChatGroupCreator standalone={this.props.standalone} done={()=>{ this.create_chat=false; }} />
                  ):(
                    <div className="h100">
                      {this.search_query?(
                          <ChatMessagesSearch standalone={this.props.standalone} ref={(ref)=>{ this._searchRef=ref; }} query={this.search_query} />
                        ):(
                        <div className="bg-w1 chatContactsPopupWrapper h100">
                          {this.renderContacts()}
                        </div>
                      )}
                    </div>

                )}
              </div>
            </div>


          </Heighter>
        </div>

      )
    }
    return null;
  }
}

function mapStateToProps(state) {
  return {
    chat_state:state.chat_state,
    me:state.me,
    t:state.translate,
  }
}

// export default connect(mapStateToProps)(ChatContacts);
export default inject("meStore","chatStore","translateStore")(observer(ChatContacts));